// assets/brands-grid.js
(() => {
  function init(section) {
    const grid = section.querySelector(".brands-grid");
    if (!grid) return;

    const reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const animateOnView = section.dataset.animateOnView === "true";
    if (reduced) return;

    const start = () => grid.setAttribute("data-animate", "true");

    if (animateOnView) {
      const io = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              start();
              obs.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      io.observe(grid);
    } else {
      start();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".section-brands-grid").forEach(init);
    });
  } else {
    document.querySelectorAll(".section-brands-grid").forEach(init);
  }
})();
